export default __webpack_public_path__ + "static/media/10.852ba20f.jpg";